import * as constant from "@/constants/constant";
import { OrganizationType } from "@/model/organization";
import * as env from "@/config/env.json";

export function sleep(ms: any) {
    const loopTime = Date.now() + ms;
    while (Date.now() < loopTime) {}
}

export function asyncFunction(f: any) {
    setTimeout(() => f(), 1);
}
export function deepCopy(o: any) {
    return JSON.parse(JSON.stringify(o));
}

export function getDate(dateTime: any) {
    const d = new Date(Number(dateTime));
    let month = (d.getMonth() + 1) as any;
    month = month < 10 ? "0" + month : month;
    let date = d.getDate() as any;
    date = date < 10 ? "0" + date : date;
    let hours = d.getHours() as any;
    hours = hours < 10 ? "0" + hours : hours;
    let minutes = d.getMinutes() as any;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let seconds = d.getSeconds() as any;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return d.getFullYear() + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
}

export function getYYYYMMDD(timestamp: any) {
    let parsedDate = new Date(timestamp);
    let yyyymmdd = "";
    let year = parsedDate.getFullYear().toString();
    let month = (parsedDate.getMonth() + 1).toString();
    let date = parsedDate.getDate().toString();
    date.length == 1 && (date = "0" + date);
    month.length == 1 && (month = "0" + month);
    yyyymmdd = year + month + date;
    return yyyymmdd;
}

export function getYYYYMM(timestamp: any) {
    let parsedDate = new Date(timestamp);

    let yyyymm = "";
    let year = parsedDate.getFullYear().toString();
    let month = (parsedDate.getMonth() + 1).toString();
    month.length == 1 && (month = "0" + month);
    yyyymm = year + month;
    return yyyymm;
}

export function getYYYY(timestamp: any) {
    let parsedDate = new Date(timestamp);
    let yyyy = "";
    let year = parsedDate.getFullYear().toString();
    yyyy = year;
    return yyyy;
}

export function getYYYYMMDD2(timestamp: any) {
    let parsedDate = new Date(timestamp);
    let yyyymmdd = "";
    let year = parsedDate.getFullYear().toString();
    let month = (parsedDate.getMonth() + 1).toString();
    let date = parsedDate.getDate().toString();
    date.length == 1 && (date = "0" + date);
    month.length == 1 && (month = "0" + month);
    yyyymmdd = `${year}-${month}-${date}`;
    return yyyymmdd;
}

export function formatDateToYYYYMMDD2(date: Date): string {
    let month = (date.getMonth() + 1).toString();
    let day = date.getDate().toString();
    month.length == 1 && (month = "0" + month);
    day.length == 1 && (day = "0" + day);
    return `${date.getFullYear()}-${month}-${day}`;
}


export function getLastEvaluatedKey(result: { [key: string]: any }): string | undefined {
    if (result && result.data && result.data.data && result.data.data.LastEvaluatedKey) {
        return result.data.data.LastEvaluatedKey;
    } else {
        return undefined;
    }
}

export function getItemListFromFunctionResult(result: { [key: string]: any }): { [key: string]: any }[] {
    if (result && result.data && result.data.data && result.data.data.Items) {
        return result.data.data.Items;
    } else {
        return [];
    }
}

export function getItemFromFunctionResult(result: { [key: string]: any }): { [key: string]: any } | null {
    if (result && result.data && result.data.data && result.data.data.Item) {
        return result.data.data.Item;
    } else {
        return null;
    }
}

export function evalFunctionResult(result: { [key: string]: any }): boolean {
    if (getResultMessage(result) === "success") {
        return true;
    } else {
        return false;
    }
}

export function getResultMessage(result: { [key: string]: any }): string {
    if (result && result.data && result.data.message) {
        return result.data.message;
    } else {
        return "";
    }
}

export function getResultError(result: { [key: string]: any }): string {
    if (result && result.data && result.data.error) {
        return result.data.error;
    } else {
        return "";
    }
}
export function getResultCode(result: { [key: string]: any }): string {
    if (result && result.data && result.data.code) {
        return result.data.code;
    } else {
        return "";
    }
}

export function parseContent(content: any) {
    let returnContent = "";
    if (content.length > 11) {
        returnContent = content.substring(0, 10) + " ...";
    } else {
        returnContent = content;
    }
    return returnContent;
}

export function getStatusString(status: string) {
    if (status === constant.orderStatus.PENDING) {
        return "대기중";
    } else if (status === constant.orderStatus.APPROVED) {
        return "승인됨";
    } else if (status === constant.orderStatus.APPROVED_TEMP_SAVE) {
        return "정보작성중";
    } else if (status === constant.orderStatus.READY) {
        return "진단대기중";
    } else if (status === constant.orderStatus.ING) {
        return "진단중";
    } else if (status === constant.orderStatus.REJECTED) {
        return "거절됨";
    } else if (status === constant.orderStatus.CANCELED) {
        return "취소됨";
    } else if (status === constant.orderStatus.COMPLETED) {
        return "완료됨";
    } else {
        return "미정";
    }
}

export function getPaidStatusString(status: string | undefined | null) {
    if (status) {
        return "결제완료";
    } else {
        return "미결제";
    }
}

export function getOrderType(type: string | undefined | null) {
    if (type == constant.orderType.BODY) {
        return "기관";
    } else if (type == constant.orderType.INDIVIDUAL) {
        return "개인";
    } else {
        return "";
    }
}

export function getYYYMMDDStringFormat(dateString?: string) {
    if (!dateString) return "N/A";

    if (dateString.length == 8) {
        return dateString.substring(0, 4) + "-" + dateString.substring(4, 6) + "-" + dateString.substring(6, 8);
    } else {
        return dateString;
    }
}

export function getGenderString(gender: string): string {
    if (!gender) return "N/A";

    if (
        gender === "남" ||
        gender === "남자" ||
        gender.toLocaleLowerCase() === "m" ||
        gender.toLocaleLowerCase() === "male"
    )
        return "남";
    else if (
        gender === "여" ||
        gender === "여자" ||
        gender.toLocaleLowerCase() === "f" ||
        gender.toLocaleLowerCase() === "female"
    )
        return "여";
    else return "N/A";
}

export const getOrganizationTypeString = (type: OrganizationType | undefined | null): string => {
    if (!type) return "N/A";
    switch (type) {
        case OrganizationType.ElementarySchool:
            return "초등학교";
        case OrganizationType.MiddleSchool:
            return "중학교";
        case OrganizationType.HighSchool:
            return "고등학교";
        case OrganizationType.University:
            return "대학교";
        case OrganizationType.Etc:
            return "기타 기관(법인/재단 등)";
        default:
            return type || "알 수 없음"; // type이 enum에 없는 문자열일 경우 그대로 반환
    }
};

export function formatNumberWithCommas(price: any): string {
    if (price) {
        const priceNum = Number(price);
        return priceNum.toLocaleString();
    } else {
        return "0";
    }
}

export function addDaysToTimestamp(timestamp: number, days: number): number {
    let date = new Date(timestamp);
    date.setDate(date.getDate() + days);
    return date.getTime();
}

export function getSurveyUrl(projectSK: string) {
    return `${env.user_domain}/Survey/${encodeURIComponent(projectSK)}`;
}
